import React, { useEffect, useState } from "react";
import classes from "./XOEasyMode.module.css";
import { useDispatch, useSelector } from "react-redux";
import { toggleTurn } from "../../store/slices/xoGameSlice/playerSlice";
import { closeModal, openModal } from "../../store/slices/xoGameSlice/xoModalSlice";
import {
    setTilesMediumMode,
    setTilesMediumModeComputer,
} from "../../store/slices/xoGameSlice/tilesSliceMedium";
import { setGameOver } from "../../store/slices/xoGameSlice/xoGameOverSlice";
import AudioPlayer from "./AudioPlayer";
import AudioComputer from "./AudioComputer";
import XOGameOver from "./XOGameOver";
import { getProfile, saveUserPoints } from "../../http/http";
import { removeUserToken } from "../../store/slices/userTokenSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { levels } from "../../utils/levels";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import GameOverAnimation from "../../animations/gameOver.json";

const XOEasyMode = () => {
    const dispatch = useDispatch();
    const { player1, computer } = useSelector((state) => state?.persisted?.playerSlice);
    const { tilesMediumMode } = useSelector(
        (state) => state?.persisted.tilesSliceMediumMode
    );
    const gameOver = useSelector((state) => state?.persised?.xoGameOverSlice);
    const [soundX, setSoundX] = useState(false);
    const [soundO, setSoundO] = useState(false);
    const [gameOverLoading, setGameOverLoading] = useState(false);
    const [winner, setWinner] = useState(null);

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    const savePoints = async (result, winner) => {
        try {
            if(gameOverLoading){
                return;
            }
            setWinner(winner);
            setGameOverLoading(true);
            const response1 = await getProfile(userToken);
            const response = await saveUserPoints(null, "X-O Game", null, 1, result == "win" ? levels?.[0]?.points : 0, response1?.data?.result?.total_points, userToken);
            setTimeout(() => {
                setGameOverLoading(false);
                setWinner(null);
            }, 1000);
            navigate("/xo-game-over", {
                state: {
                    result,
                    winner,
                    level: 1
                }
            })
        } catch (error) {
 setGameOverLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    const handleTileClick = (data) => {
        setSoundO(false);
        setSoundX(true);
        const filled = tilesMediumMode.some((item) => item.index == data.index);
        if (player1 && !filled) {
            dispatch(setTilesMediumMode({ index: data.index, value: "X" }));
            dispatch(toggleTurn());
        }
    };

    function doesObjectExistAtIndexWithValue(array, indexToCheck, valueToCheck) {
        const foundObject = array.find((obj) => obj.index === indexToCheck);

        return foundObject && foundObject.value === valueToCheck;
    }

    useEffect(() => {
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 2, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 2, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 4, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 6, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 4, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 6, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 8, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 8, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 4, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 4, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 2, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 8, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 2, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 8, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 6, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 6, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 1, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 9, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "X") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "X")
        ) {
            dispatch(setGameOver());
            savePoints("win", "Player X won the game!");
        }
        if (
            doesObjectExistAtIndexWithValue(tilesMediumMode, 3, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 5, "O") &&
            doesObjectExistAtIndexWithValue(tilesMediumMode, 7, "O")
        ) {
            dispatch(setGameOver());
            savePoints("lose", "Player O won the game!");
        }
    }, [tilesMediumMode]);

    useEffect(() => {
        const over = gameOver;
        if (tilesMediumMode?.length === 9 && !over) {
            setTimeout(() => {
                dispatch(setGameOver());
                savePoints("draw", "It's a Draw!");
            }, 600);
        }
    }, [tilesMediumMode, gameOver]);

    useEffect(() => {
        const over = gameOver;
        if (computer && tilesMediumMode?.length !== 9 && !over) {
            setTimeout(() => {
                setSoundX(false);
                setSoundO(true);
                dispatch(setTilesMediumModeComputer());
                dispatch(toggleTurn());
            }, 600);
        }
    }, [computer, gameOver]);

    const renderTiles = () => {
        const tilesArray = new Array(9).fill(null);

        return tilesArray.map((_, index) => (
            <div
                key={index}
                className={`${index + 1 === 1
                    ? classes.tile_one
                    : index + 1 === 2
                        ? classes.tile_two
                        : index + 1 === 3
                            ? classes.tile_three
                            : index + 1 === 4
                                ? classes.tile_four
                                : index + 1 === 5
                                    ? classes.tile_five
                                    : index + 1 === 6
                                        ? classes.tile_six
                                        : index + 1 === 7
                                            ? classes.tile_seven
                                            : index + 1 === 8
                                                ? classes.tile_eight
                                                : classes.tile_nine
                    }`}
                onClick={() => handleTileClick({ index: index + 1 })}
            >
                {Array.isArray(tilesMediumMode)
                    ? tilesMediumMode.map((tile) => {
                        console.log(tile, "t");
                        return (
                            <h1
                                style={
                                    tile?.value === "X"
                                        ? { color: "#e8d615", fontSize: "70px" }
                                        : {
                                            color: "white",
                                            fontSize: "70px",
                                        }
                                }
                            >
                                {tile?.index === index + 1 ? tile?.value : null}
                            </h1>
                        );
                    })
                    : null}
            </div>
        ));
    };

    return (
        <div className={classes.container}>
            <div className={classes.sub_container}>

                {soundX ? <AudioPlayer /> : soundO ? <AudioComputer /> : null}

                <div className={classes.player_turn_indicator}>
                    <h1>
                        {player1
                            ? t("163")
                            : computer
                                ? t("164")
                                : null}
                    </h1>
                </div>

                <div className={classes.grid_container}>
                    <img
                        src="/assets/images/background-grid.jpg"
                        className={classes.bg_img}
                    />
                    <div className={classes.grid}>{renderTiles()}</div>
                </div>

                {gameOverLoading && (
                    <div className={classes.game_over_animation_container}>
                        <Lottie animationData={GameOverAnimation} loop autoPlay className={classes.gameOverAnimation} />
                        <h1>{winner}</h1>
                    </div>
                )}
            </div>
        </div>
    );
};

export default XOEasyMode;
